export const getNewsImg = (htmlString, defaultImg) => {
  const tempEl = document.createElement('div')
  tempEl.innerHTML = htmlString
  const imgUrl = tempEl.querySelector('img')?.src
  return imgUrl ? imgUrl : defaultImg
}
